// yads_type_tagの出し分けのため、とりあえず必要な箇所のページを羅列する
export const Page = {
  TOP: 'top',
  PICKUP: 'pickup',
  ARTICLES: 'articles',
  COMMENTS: 'comments',
  PHOTO: 'photo'
} as const;

export type Page = (typeof Page)[keyof typeof Page];
